import { Outlet } from 'react-router-dom'
import Launchshow from '../components/launchshow/LaunchShowSection'
import styles from '../styles/userEntryLayout.module.scss'

const Signup=()=>{
return (
   <div className={styles.body}>
    <Launchshow></Launchshow>
    <Outlet></Outlet>
   </div>
)
}

export default Signup